import { useEffect } from "react";
import {
  useCountryBlockingActions,
  useCountryBlockingHasBeenChecked,
  useIsCountryBlockingBlocked,
  useIsCountryBlockingChecking,
} from "../../core_stores/useCountryBlockingStore";
import { NoAccessContent } from "../common_components/NoAccessContent";

interface CountryBlockingWrapperProps {
  children: React.ReactNode;
}

export function CountryBlockingWrapper({
  children,
}: CountryBlockingWrapperProps) {
  const isChecking = useIsCountryBlockingChecking();
  const isBlocked = useIsCountryBlockingBlocked();
  const hasBeenChecked = useCountryBlockingHasBeenChecked();
  const { checkAccess } = useCountryBlockingActions();

  useEffect(() => {
    checkAccess();
  }, [checkAccess]);

  // Show loading while checking
  if (isChecking || !hasBeenChecked || isBlocked) {
    return (
      <NoAccessContent
        isLoading={isChecking}
        info="Looks like Darvin is not available in your country :("
      />
    );
  }

  // Show normal app if user is allowed
  return <>{children}</>;
}
